import { useEffect, useRef, useState } from "react";
import { getLocalStorageItem } from "../utils/localStorage";
import { startCamera, stopCamera } from "../utils/helpers";

const useLivePicture = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const streamRef = useRef<MediaStream | null>(null);
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const [imageFile, setImageFile] = useState<File | null>(null);
  const userDetails = getLocalStorageItem("userDetails");
  const { firstName = "", lastName = "" } = userDetails || {};

  useEffect(() => {
    startCamera(videoRef, streamRef);

    return () => {
      stopCamera(videoRef, streamRef);
    };
  }, []);

  const restartCamera = () => {
    endCamera();
    startCamera(videoRef, streamRef);
  };

  const endCamera = () => {
    stopCamera(videoRef, streamRef);
    setImageSrc(null);
    setImageFile(null);
  };

  const capturePhoto = () => {
    if (canvasRef.current && videoRef.current) {
      const ctx = canvasRef.current.getContext("2d");
      if (ctx) {
        ctx.drawImage(
          videoRef.current,
          0,
          0,
          canvasRef.current.width,
          canvasRef.current.height
        );
        setImageSrc(canvasRef.current.toDataURL("image/png"));
        canvasRef.current.toBlob((blob) => {
          if (blob) {
            const file = new File([blob], `${firstName}_${lastName}.png`, {
              type: "image/png",
            });
            setImageFile(file);
          }
        }, "image/png");
      }
    }
  };

  return {
    capturePhoto,
    imageSrc,
    videoRef,
    canvasRef,
    streamRef,
    restartCamera,
    endCamera,
    imageFile,
  };
};

export default useLivePicture;
